import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import styled from 'styled-components';
import { ScrollToBottom } from '../../ClerkScreen/Chat/ScrollToBottom';
import { breakpoints } from '../../../../shared/utils/styles';

export const SellerMessages = () => {
  const {
    AuctionStore: {
      auctionLaneId,
    },
    BidStore: {
      auction,
    },
    MessageStore: {
      directMessageLog,
      messaging,
      handleSetFilteredMessageData,
    },
  } = useStores();
  const { filteredMessageData } = messaging;

  const allowScroll = true;
  const strLog = JSON.stringify(directMessageLog);
  useEffect(() => {
    handleSetFilteredMessageData(directMessageLog);
  }, [auction, directMessageLog, handleSetFilteredMessageData, auction.lotNumber, auctionLaneId, strLog]);

  return (
    <SellerMessagesContainer>
      <div>
        <div>SELLER COMMUNICATIONS</div>
        {/*{laneSuspended && currentBid < reserveNotMetAlertThreshold && <ReserveThresholdWarning>*/}
        {/*  below reserve threshold (${reserveNotMetAlertThreshold})*/}
        {/*</ReserveThresholdWarning>}*/}
        <div>
          {filteredMessageData
            ?.filter((message) => message.userType === 'Seller')
            ?.filter((message) => message.itemNumber === auction.lotNumber)
            ?.map((message) => (
              <div key={message.id}>
                <div>{message.content}</div>
                <div>{message.timestamp}</div>
              </div>
            ))}
          {filteredMessageData?.length > 1 && allowScroll && <ScrollToBottom />}
        </div>
      </div>
    </SellerMessagesContainer>
  );
};

export default observer(SellerMessages);

const ReserveThresholdWarning = styled.span`
  text-align: center;
  background-color: red;
  color: white;
  padding: 10px;
`;

export const SellerMessagesContainer = styled.div`
grid-area: messages;
display: flex;
flex-direction: column;
align-items: center;
background-color: #eee;
border: 1px solid gray;
padding: 0px 5px;
text-transform: uppercase;
> div:first-child {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-width: 100%;
  align-items: center;
  & > div:nth-child(1) {
    text-transform: uppercase;
    font-size: 2em;
    @media (max-width: ${breakpoints.auctioneer.small}) {
      font-size: 1.5em;
    }
    font-weight: bold;
    padding-top: 5px;
    border-bottom: 1px solid gray;
    margin-bottom: 5px;
  }
  & > div:not(:first-child) {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 415px;
    min-height: 100%;
    min-width: 100%;
    overflow-y: auto;
    font-size: 1em;
    @media (max-width: ${breakpoints.auctioneer.small}) {
      font-size: .7em;
    }
    > div {
      background-color: #BFBCAC;
      border: none;
      box-sizing: border-box;
      border-radius: 3px;
      margin: 3px;
      padding: 10px;
      font-size: min(1.7em, 2.5em);
      min-width: 100%;
      text-transform: none;
      display: flex;
      justify-content: space-between;
      & div:first-child {
        overflow: hidden;
        width: 240px;
      }
      & div:last-child {
        min-width: 100px;
        text-align: right;
        font-size: .8em;
      }
    }
    & .scroll-to-bottom {
      background-color: transparent;
    }
  }
}
`;
